import React from 'react';

export default function MapContainer({children}) {
  return <div className="d-flex h-100">{children}</div>;
}
